import React from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { SuggestedFollowee } from 'js/core_post_webpack/models/user';
import AvatarBase, { Name as NameBase } from './shared/Avatar';
import { ImpressionWatcher, ImpressionEntity } from 'js/utils/impressions';
import {
  getSocialImpressionSource,
  serializeUserSuggestionScoringMetadata,
} from './ImpressionHelper';
import { LinkButton } from 'js/social/shared/design_system/LinkButton';
import _Container from "SuggestedUserCard-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/SuggestedUserCard.tsx?styleId=Container";
import _UserSection from "SuggestedUserCard-UserSection.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/SuggestedUserCard.tsx?styleId=UserSection";
import _Avatar from "SuggestedUserCard-Avatar.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/SuggestedUserCard.tsx?styleId=Avatar";
import _UserInfo from "SuggestedUserCard-UserInfo.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/SuggestedUserCard.tsx?styleId=UserInfo";
import _University from "SuggestedUserCard-University.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/SuggestedUserCard.tsx?styleId=University";
import _Name from "SuggestedUserCard-Name.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/SuggestedUserCard.tsx?styleId=Name";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const UserSection = /*#__PURE__*/styled("div", null, {
  displayName: "UserSection",
  styles: _UserSection
});

const Avatar = /*#__PURE__*/styled(AvatarBase, null, {
  displayName: "Avatar",
  styles: _Avatar
});

const UserInfo = /*#__PURE__*/styled("div", null, {
  displayName: "UserInfo",
  styles: _UserInfo
});

const University = /*#__PURE__*/styled(Body, null, {
  displayName: "University",
  styles: _University
});

const Name = /*#__PURE__*/styled(NameBase, null, {
  displayName: "Name",
  styles: _Name
});

const IMPRESSION_PAGE = 'home';
const IMPRESSION_SECTION = 'sugg';

interface Props {
  user: SuggestedFollowee;
  followUser: (id: number) => void;
  scoring?: { [key: string]: any };
}

const SuggestedUserCard: React.FC<Props> = ({ user, followUser, scoring }) => {
  return (
    <Container>
      <UserSection>
        <ImpressionWatcher
          source={getSocialImpressionSource(
            IMPRESSION_PAGE,
            IMPRESSION_SECTION,
            'prof-p',
          )}
          entity_type={ImpressionEntity.User}
          entity_id={user.id}
        >
          <Avatar
            fullName={user.display_name as string}
            photoUrl={user.photo}
            profileUrl={user.url}
          />
        </ImpressionWatcher>
        <UserInfo>
          <ImpressionWatcher
            source={getSocialImpressionSource(
              IMPRESSION_PAGE,
              IMPRESSION_SECTION,
              'prof-n',
            )}
            entity_type={ImpressionEntity.User}
            entity_id={user.id}
            extra={{
              scoring: serializeUserSuggestionScoringMetadata(scoring),
            }}
          >
            <Name href={user.url}>
              {user.display_name || user.first_name + ' ' + user.last_name}
            </Name>
          </ImpressionWatcher>
          {user.department?.university?.name && (
            <University>{user.department?.university?.name}</University>
          )}
          <LinkButton onClick={() => followUser(user.id)}>Follow</LinkButton>
        </UserInfo>
      </UserSection>
    </Container>
  );
};

export default SuggestedUserCard;
